// src/router/history.js
export const routeHistory = []
